import { Card, Frame } from "@shopify/polaris"
import React, { Component } from "react"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import Actions from "../../../actions"
import { CONFIG } from "../../../config"
import AppBodyNotifications from "../AppBodyNotifications"
import AppBodyWishlist from "../AppBodyWishlist"
import AppBodyPreOrder from "../AppBodyPreOrder"
import AppManaged from "../../../pages/AppManaged"
import BiSPage from "../../../pages/BiSPage"
import PlanPage from "../../../pages/Plan"
import SupportPage from "../../../pages/Support"
import Contact from "../../../pages/Contact"
import AppHeader from "../AppHeader"
import Feedback from "../Feedback"
import Suggests from "../Suggests"
import "./styles.scss"
import IntegrationPage from "../../../pages/IntegrationPage"
function mapStateToProps(state) {
    return {
        store: state,
        parent_pages: state.parent_pages,
        yout_app: state.yout_app,
        widgets: state.widgets,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Actions, dispatch),
    }
}

const INITIAL_STATE = {
    isReady: false,
    isLoading: false,
    toast: {
        show: false,
        content: "",
        error: false,
    },
    show_add_section: false,
}

class AppMain extends Component {
    constructor(props) {
        super(props)
        this.state = Object.assign({}, INITIAL_STATE)
    }

    componentDidMount() {
        // this.initAppData();
    }

    handleShow = () => {
        this.props.handleShow()
    }

    renderComponent = () => {
        const { parent_pages } = this.props
        const { checkInstall, optionThemes, selected, checkClose, themesInstall, metafieldId } =
            this.props
        let clientUrl1 = "electro-5-demo.myshopify.com"

        if (window.parentUrl === clientUrl1) {
            switch (parent_pages.selected) {
                case 0:
                    return (
                        <AppBodyWishlist
                            themesInstall={themesInstall}
                            checkClose={checkClose}
                            checkInstall={checkInstall}
                            optionThemes={optionThemes}
                            selected={selected}
                            metafieldId={metafieldId}
                            handleShow={this.handleShow}
                        />
                    )

                case 1:
                    return <AppBodyPreOrder />

                case 2:
                    return <Contact />

                case 3:
                    return <AppBodyNotifications />

                case 4:
                    return <PlanPage />

                case 5:
                    return <SupportPage />
                case 6:
                    return <AppManaged />

                case 7:
                    return <IntegrationPage />

                default:
                    return <AppBodyWishlist />
            }
        } else {
            switch (parent_pages.selected) {
                case 0:
                    return (
                        <AppBodyWishlist
                            themesInstall={themesInstall}
                            checkClose={checkClose}
                            checkInstall={checkInstall}
                            optionThemes={optionThemes}
                            selected={selected}
                            metafieldId={metafieldId}
                            handleShow={this.handleShow}
                        />
                    )
                case 1:
                    return <PlanPage />

                case 2:
                    return <SupportPage />

                case 3:
                    return <IntegrationPage />

                default:
                    return <AppBodyWishlist />
            }
        }
    }

    render() {
        return (
            <div className="yta-main">
                <Frame>
                    <div className="yta-body">
                        <AppHeader />

                        <div className="page-wrapper">
                            <Card>
                                <Card.Section>{this.renderComponent()}</Card.Section>
                            </Card>
                        </div>

                        {/* <Suggests /> */}

                        <Feedback
                            app_name={CONFIG.APP_NAME}
                            review_url="https://apps.shopify.com/youtube-feed-by-arena#modal-show=ReviewListingModal"
                            support_url="https://support.arenacommerce.com/support/solutions/6000139751"
                            contact_url="https://support.arenacommerce.com/support/tickets/new"
                        />
                    </div>
                </Frame>
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AppMain)
